/**
 * Created by fulle on 2023/02/07.
 */
import http from "@/http-common";
import CUSTOM_CONSTANTS from "@/constants";
import { isNumeric } from "@/app/helpers"


export default {
  state: {
      selected: null,
      list: {
          all: null,
          paginated: null,
          organisation: null
      },
      pagination: null,
      links: null

  },
  mutations: {
      SET_LIST_ALL_LEAVETYPE: (state, _value) => {
          state.list.all = _value;
      },
      SET_LIST_LEAVETYPE_ORGANISATION: (state, _value) => {
          state.list.organisation = _value;
      },
      SET_SELECTED_LEAVETYPE: (state, _value) => {
          state.selected = _value;
      },
      SET_LEAVETYPE_LIST_PAGINATED: (state, _value) => {
          state.list.paginated = _value;
      },
      UPDATE_LEAVETYPE_LIST_PAGINATED: (state, _value) => {
          Array.prototype.push.apply(state.list.paginated,_value)
          let _arr = state.list.paginated
          state.list.paginated = _arr.filter((value, index) => {
              const _value = JSON.stringify(value);
              return index === _arr.findIndex(obj => {
                      return JSON.stringify(obj) === _value;
                  });
          });
      },
      SET_LEAVETYPE_PAGINATION: (state, _value) => {
          state.pagination = _value;
      },
      SET_LEAVETYPE_PAGINATION_LINKS: (state, _value) => {
          state.links = _value;
      },
  },
  actions: {
      COMMIT_SET_SELECTED_LEAVETYPE: ({ commit}, _value) => {
          commit("SET_SELECTED_LEAVETYPE", _value);
      },
      COMMIT_SET_LEAVETYPE_LIST_PAGINATED: ({ commit}, _value) => {
          commit("SET_LEAVETYPE_LIST_PAGINATED", _value);
      },
      REQUEST_LEAVETYPE_LIST_PAGINATED: ({ commit,dispatch }, _formData) => {
          commit("START_PROCESSING", { root: true });
          dispatch("COMMIT_SESSION_REFRESH_AUTH", null, { root: true });
          return new Promise(resolve => {
              http({
                  url: '/leave/type/select',
                  method: "POST",
                  timeout: 60000,
                  data: _formData
              })
                  .then(_response => {
                      window.console.log("Response LEAVETYPE PAGINATED LIST: ", _response);
                      if(_response.data.success === false || parseInt(_response.data.error_code)>0)
                      {
                          reject(_response)
                          return false
                      }
                      let _page = 1
                      if(typeof _formData !== "undefined" && _formData !== null)
                      {
                          if(typeof _formData.page !== "undefined" && _formData.page !== null && isNumeric(_formData.page)&&parseInt(_formData.page)>0)
                              _page = parseInt(_formData.page)
                      }
                      if(_page <= 1)
                          commit('SET_LEAVETYPE_LIST_PAGINATED', _response.data.data);
                      else
                          commit('UPDATE_LEAVETYPE_LIST_PAGINATED', _response.data.data);
                      commit('SET_LEAVETYPE_PAGINATION', _response.data.pagination);
                      commit('SET_LEAVETYPE_PAGINATION_LINKS', _response.data.links);
                      commit("STOP_PROCESSING", { root: true });
                      resolve(_response);
                  })
                  .catch(_response => {
                      commit("STOP_PROCESSING", { root: true });
                      dispatch("RESPONSE_PROCESS_AJAX_ERROR", _response);
                  });
          });
      },
      REQUEST_LEAVETYPE_LIST_SELECT: ({ commit,dispatch }, _formData) => {
          commit("START_PROCESSING", { root: true });
          dispatch("COMMIT_SESSION_REFRESH_AUTH", null, { root: true });
          return new Promise(resolve => {
              http({
                  url: '/leave/type/select',
                  method: "POST",
                  timeout: 60000,
                  data: _formData
              })
                  .then(_response => {
                      window.console.log("Response LEAVETYPE PAGINATED LIST: ", _response);
                      if(_response.data.success === false || parseInt(_response.data.error_code)>0)
                      {
                          reject(_response)
                          return false
                      }
                      commit('SET_LIST_ALL_LEAVETYPE', _response.data.data);
                      commit("STOP_PROCESSING", { root: true });
                      resolve(_response);
                  })
                  .catch(_response => {
                      commit("STOP_PROCESSING", { root: true });
                      dispatch("RESPONSE_PROCESS_AJAX_ERROR", _response);
                  });
          });
      },
      REQUEST_LEAVETYPE_ORGANISATION_LIST_SELECT: ({ commit,dispatch }, _formData) => {
          commit("START_PROCESSING", { root: true });
          dispatch("COMMIT_SESSION_REFRESH_AUTH", null, { root: true });
          return new Promise(resolve => {
              http({
                  url: '/leave/type/organisation/select',
                  method: "POST",
                  timeout: 60000,
                  data: _formData
              })
                  .then(_response => {
                      window.console.log("Response LEAVETYPE ORGANISATION LIST: ", _response);
                      if(_response.data.success === false || parseInt(_response.data.error_code)>0)
                      {
                          reject(_response)
                          return false
                      }
                      commit('SET_LIST_LEAVETYPE_ORGANISATION', _response.data.data);
                      commit("STOP_PROCESSING", { root: true });
                      resolve(_response);
                  })
                  .catch(_response => {
                      commit("STOP_PROCESSING", { root: true });
                      dispatch("RESPONSE_PROCESS_AJAX_ERROR", _response);
                  });
          });
      },
      REQUEST_LEAVETYPE_ORGANISATION_SAVE: ({ commit,dispatch, reject }, _formData) => {
          dispatch("COMMIT_SESSION_REFRESH_AUTH", null, { root: true });
          commit("START_PROCESSING", { root: true });
          return new Promise(resolve => {
              http({
                  url: '/leave/type/organisation/save',
                  method: "POST",
                  timeout: 30000,
                  data: _formData,
              })
                  .then(_response => {
                      window.console.log("Response ORGANISATION LEAVE TYPE STORE: ", _response);
                      commit("STOP_PROCESSING", { root: true });
                      if(_response.data.success === false || parseInt(_response.data.error_code)>0)
                      {
                          reject(_response)
                          return false
                      }
                      resolve(_response);
                  })
                  .catch(_response => {
                      commit("STOP_PROCESSING", { root: true });
                      dispatch("RESPONSE_PROCESS_AJAX_ERROR", _response);
                  });
          });
      },

  },
};
